import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'readTime',
  standalone: true
})
export class ReadTimePipe implements PipeTransform {

  transform(text: string): string {
    let readTime = '';
    const wordsPerMinutes = 225;
    const words = text.trim().split(/\s+/)?.length;
    readTime = `خواندن ${Math.ceil(words / wordsPerMinutes)} دقیقه`
    return readTime;
  }

}
